import React, { Fragment } from 'react';
import { Button, Popover } from '@material-ui/core';
import { RootStateOrAny, useSelector } from 'react-redux';
import InfiniteCalendar, { withRange, Calendar } from 'react-infinite-calendar';
import { localesMap } from '../OperationHoursTab/OperationHoursCalendar';
import moment from 'moment';
import styles from './styles';
import { useTranslation } from 'react-i18next';

interface RBICalenderSearchInterface {
  selectedStartDate: moment.Moment;
  selectedEndDate: moment.Moment;
  onChangeInput?: (startDate: moment.Moment, endDate: moment.Moment) => void;
  handleApplyButton: (name: string | undefined, value: any) => void;
  handleOnClosePopUp?: () => void;
  id: string;
  textButton?: string;
}

const RBICalenderSearch = ({
  selectedStartDate,
  selectedEndDate,
  onChangeInput = () => {
    // No-op: Default implementation
  },
  handleApplyButton,
  handleOnClosePopUp,
  id,
  textButton = '',
}: RBICalenderSearchInterface) => {
  const classes = styles();
  const { selectedLanguage } = useSelector(
    (state: RootStateOrAny) => state.AppReducer.selectedLanguage,
  );
  const [anchorElPopover, setAnchorElPopover] =
    React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    setAnchorElPopover(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorElPopover(null);
    handleOnClosePopUp && handleOnClosePopUp();
  };

  const onApplyButton = () => {
    handleApplyButton(id, {
      startDate: selectedStartDate,
      endDate: selectedEndDate,
    });
    handlePopoverClose();
  };

  const onSelectDate = e => {
    if (e.eventType === 3) {
      const startDate = moment(e.start).startOf('day');
      const endDate = moment(e.end).startOf('day');
      onChangeInput(startDate, endDate);
    }
  };
  const { t } = useTranslation();

  return (
    <Fragment>
      <Button
        variant="outlined"
        classes={{
          label: classes.availabilityFilterLabel,
          root: classes.availabilityButton,
        }}
        onClick={handlePopoverOpen}
      >
        {selectedStartDate.format('L')}-{selectedEndDate.format('L')}
      </Button>
      <Popover
        open={Boolean(anchorElPopover)}
        onClose={handlePopoverClose}
        anchorEl={anchorElPopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{
          paper: `${classes.searchButtonPopover} `,
        }}
      >
        <div className={`${classes.flexSpaceBetween}`}>
          <InfiniteCalendar
            id={id}
            locale={{
              headerFormat: 'MMM Do',
              locale:
                localesMap[
                  selectedLanguage ||
                    localStorage.getItem('selectedLanguage') ||
                    'en'
                ],
              blank: t('app.common.calendar.selectADate'),
              todayLabel: {
                long: t('app.common.calendar.today', 'today'),
                short: t('app.common.calendar.today', 'Today'),
              },
              weekdays: [
                t('app.common.calendar.sunday_short', 'sun'),
                t('app.common.calendar.monday_short', 'mon'),
                t('app.common.calendar.tuesday_short', 'tue'),
                t('app.common.calendar.wednesday_short', 'wed'),
                t('app.common.calendar.thursday_short', 'thu'),
                t('app.common.calendar.friday_short', 'fri'),
                t('app.common.calendar.saturday_short', 'sat'),
              ],
              weekStartsOn: 0,
            }}
            theme={{
              selectionColor: 'rgb(162, 162, 162)',
              headerColor: 'rgb(138, 138, 138)',
              weekdayColor: 'rgb(216, 216, 216)',
            }}
            width={'100%'}
            height={350}
            rowHeight={50}
            selected={{
              start: selectedStartDate.format('YYYY-MM-DD'),
              end: selectedEndDate.format('YYYY-MM-DD'),
            }}
            Component={withRange(Calendar)}
            onSelect={onSelectDate}
          />
          <Button
            className={classes.buttonApply}
            size="small"
            variant="contained"
            color="primary"
            onClick={onApplyButton}
          >
            {textButton || t('app.common.filter')}
          </Button>
        </div>
      </Popover>
    </Fragment>
  );
};

export default RBICalenderSearch;
